import React from 'react'
import { Link as ReactLink, LinkProps } from 'react-router-dom'
import { IconButtonProps, IconButton, Box, BoxProps } from '@chakra-ui/core'

type LinkButtonProps = IconButtonProps & LinkProps

export const LinkButton: React.FC<LinkButtonProps> = React.forwardRef(
    (props: LinkButtonProps, ref: React.Ref<JSX.Element>) => {
        return <IconButton ref={ref} as={ReactLink} {...props} />
    }
)
LinkButton.displayName = 'LinkButton'

type BoxLinkButtonProps = BoxProps & LinkProps

export const BoxLinkButton: React.FC<BoxLinkButtonProps> = React.forwardRef(
    (props: BoxLinkButtonProps, ref: React.Ref<JSX.Element>) => {
        return <Box ref={ref} as={ReactLink} {...props} />
    }
)

BoxLinkButton.displayName = 'BoxLinkButton'
